import { render, staticRenderFns } from "./FeedEfficiency.vue?vue&type=template&id=f90e80c0&scoped=true"
import script from "./FeedEfficiency.vue?vue&type=script&lang=js"
export * from "./FeedEfficiency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90e80c0",
  null
  
)

export default component.exports